import { render, staticRenderFns } from "./EmployeeCertification.vue?vue&type=template&id=b15cf670&scoped=true&"
import script from "./EmployeeCertification.vue?vue&type=script&lang=js&"
export * from "./EmployeeCertification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15cf670",
  null
  
)

export default component.exports